import React, { useEffect, useState } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import SsoErrorPage from "../ErrorPage/SsoErrorPage";
import Spinner, { SpinnerSize } from "../../UI/Spinner/Spinner";
import * as AuthenticationActions from "../../../middleware/Store/Actions/AuthenticationActions";
import * as LogoutUtils from "../../Utils/LogoutUtils";
import * as ContactUtils from "../../Utils/ContactUtils";
import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "LOGIN_SSO";

const LoginSso = (props) => {
    const location = useLocation();
    const [display, setDisplay] = useState(
        <div className="py-xl state">
            <span className="state-icon">
                <Spinner size={SpinnerSize.Big} />
            </span>
        </div>);

    useEffect(() => {
        LogService.info(LOG_TAG, "useEffect location");

        if (LogoutUtils.isSsoPath(location)) {
            const token = LogoutUtils.getSsoTokenFromLocation(location);
            const ssoErrorPayload = LogoutUtils.getSsoErrorFromLocation(location);
            if (token)
                props.loginSso(token);
            else if (ssoErrorPayload)
                setDisplay(<SsoErrorPage errorPayload={ssoErrorPayload} />);
            else
                setDisplay(<Redirect to={LogoutUtils.ROOT_PATH} />);//routing might then change path
        }
    }, [location]);

    useEffect(() => {
        LogService.info(LOG_TAG, "useEffect user");

        if (ContactUtils.isUserFullyLoaded(props.user))
            setDisplay(<Redirect to={LogoutUtils.DASHBOARD_PATH} />);
    }, [props.user]);


    return display;
}

const mapStateToProps = state => {
    return {
        user: state.contacts.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loginSso: (token) => dispatch(AuthenticationActions.loginSso(token))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginSso);